import React from 'react'
import {Link} from 'react-router-dom'
import './back-link.css'

const BackLink = ({href}) => {
  return (<Link to={href} className="back-link">Back</Link>);
};

export default BackLink;


// WEBPACK FOOTER //
// ./src/components/common/back-link/index.jsx